import VaspEmailConfirmation from './VaspEmailConfirmation'

export default VaspEmailConfirmation
